import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinmumbai() {



  const cardData =
  {
    keyword: 'Mini Bus on Rent in Mumbai ',
    heading: 'Shambhu Cabs: Mini Bus on Rent in Mumbai',
    headingDescription: 'Shambhu Cabs offers reliable Mini Bus on Rent in Mumbai, providing safe, comfortable, and spacious travel for large groups, corporate teams, school trips, and tourist excursions. Our well-maintained mini buses ensure a smooth and enjoyable journey with ample seating, luggage space, and modern amenities for long-distance travel, city tours, airport transfers, and special events. With professional chauffeurs, flexible one-way and round-trip rental options, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes group travel convenient, stress-free, and comfortable. For dependable service, safety, and a seamless travel experience, Shambhu Cabs is your trusted choice for mini bus rental in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch commemorating the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it stands as a historic entry point for British governors and a symbol of colonial-era architecture. Visitors enjoy ferry rides to Elephanta Island, street food stalls, coastal photography, and a lively promenade. Its illuminated evenings create a stunning waterfront ambiance that reflects the essence of Mumbai."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s famous 3.6 km-long coastline, known for its curved boulevard that glitters like a ‘Queen’s Necklace’ at night. The promenade is ideal for morning jogs, romantic walks, cycling, and enjoying refreshing sea breezes. The Art Deco buildings lining the stretch add heritage value, making it one of the world’s largest collections of Art Deco architecture. Sunsets here are especially mesmerizing, drawing locals, tourists, and photographers to soak in the city’s vibrant coastal charm."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is an architectural masterpiece blending Victorian Gothic Revival and Indian traditional designs. Built in 1887, it is one of India’s busiest railway stations and a symbol of Mumbai’s historic importance. Its grand domes, stained glass windows, carvings of flora and fauna, and intricate pillars make it a living museum. The nighttime lighting further enhances its majesty, making it a must-visit landmark for history, architecture, and photography enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its vibrant street food culture, local entertainers, and stunning sunsets. Visitors indulge in Mumbai’s iconic snacks like pav bhaji, bhel puri, and gola while enjoying camel rides, kite flying, and beach sports. The beach is also frequently visited by Bollywood celebrities who live in the surrounding areas. Its lively yet relaxed atmosphere makes it a perfect escape for families, couples, and tourists."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, believed to fulfill devotees’ wishes. The temple’s wooden doors depict Ashtavinayak carvings, and the gold-plated sanctum adds to its spiritual aura. Thousands queue up daily for darshan, including celebrities and leaders. During Ganesh Chaturthi, the entire area comes alive with devotional music, lights, and vibrant processions, showcasing Mumbai’s deep spiritual culture."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on an islet connected by a narrow causeway, is a stunning Indo-Islamic structure honoring Sufi saint Pir Haji Ali Shah Bukhari. Surrounded by the sea on all sides, it offers breathtaking views and a serene spiritual experience. The white marble structure, religious hymns, and peaceful setting attract visitors of all faiths. The walk to the dargah during low tide is a unique experience, blending spirituality with natural beauty."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site located on Elephanta Island, feature ancient rock-cut sculptures dedicated primarily to Lord Shiva. The 5th–8th century caves include magnificent carvings like the massive Trimurti (three-faced Shiva), Nataraja, and various mythological scenes. Visitors reach the island via ferry from the Gateway of India, experiencing a combination of history, art, nature, and coastal adventure."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel connecting Mumbai’s western suburbs to South Mumbai. Its cable-stayed architecture, sweeping curves, and views of the Arabian Sea make it a visual delight. The bridge significantly reduces travel time and symbolizes Mumbai’s urban growth. Sunrise, sunset, and nighttime views with illuminated cables provide spectacular photographic opportunities."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, one of India’s oldest and most famous flea markets, is renowned for antiques, vintage Bollywood memorabilia, gramophones, cameras, and rare collectibles. Walking through its busy lanes offers a glimpse into Mumbai’s historic trade culture. Bargain hunters, designers, and collectors explore the market to discover unique treasures. The chaotic yet vibrant atmosphere makes it an exciting spot for cultural enthusiasts and photographers."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park spans over 100 sq km in northern Mumbai, serving as a biodiversity hotspot and city escape. Visitors enjoy nature trails, lion and tiger safaris, boating, cycling, and trekking. The ancient Kanheri Caves within the park provide historical and archaeological interest. Home to leopards, monkeys, deer, and hundreds of bird species, it offers a jungle retreat in the middle of the city, perfect for adventure and nature enthusiasts."
  },
  {
    "title": "Mount Mary Church",
    "description": "The Basilica of Our Lady of the Mount, popularly called Mount Mary Church, is a Roman Catholic church atop a hill in Bandra. Known for its Gothic architecture, peaceful interiors, and panoramic views of the sea, it attracts devotees and tourists alike. The annual Bandra Fair in September draws large crowds for prayers, cultural programs, and local food. The church symbolizes Mumbai’s religious harmony and cultural diversity."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda in Gorai is a massive meditation hall and a monument to peace. Featuring the world’s largest stone dome built without supporting pillars, it serves as a center for learning Vipassana meditation. The pagoda’s serene atmosphere, golden interiors, and scenic gardens attract spiritual seekers and tourists. Visitors gain insight into India’s meditation traditions while enjoying panoramic views of the surrounding landscapes."
  }
],



"services": [
  {
    "name": "Mini Bus Hire Mumbai",
    "description": "Mini Bus Hire Mumbai provides spacious and comfortable mini buses for city travel, group outings, corporate trips, and airport transfers. Ideal for groups seeking reliable transport with professional drivers."
  },
  {
    "name": "20-Seater Bus Mumbai",
    "description": "20-Seater Bus Mumbai is perfect for medium-sized groups traveling within the city or for short outstation trips. Equipped with AC and comfortable seating for a smooth ride."
  },
  {
    "name": "27-Seater Bus Rental",
    "description": "27-Seater Bus Rental Mumbai caters to larger groups for city tours, corporate events, or long-distance travel. Spacious interiors and professional drivers ensure a comfortable journey."
  },
  {
    "name": "AC Mini Bus Mumbai",
    "description": "AC Mini Bus Mumbai offers air-conditioned group transport for local city trips, outstation journeys, and airport pickups. Ideal for family outings, corporate events, and tourist trips."
  },
  {
    "name": "Mini Bus Outstation Mumbai",
    "description": "Mini Bus Outstation Mumbai provides reliable transport for long-distance trips. Comfortable seating, AC options, and experienced drivers ensure a safe and convenient journey."
  },
  {
    "name": "Corporate Bus Rental Mumbai",
    "description": "Corporate Bus Rental Mumbai is designed for office trips, corporate events, and employee transportation. Timely pickups, AC options, and professional service make business travel seamless."
  },
  {
    "name": "School Trip Mini Bus Mumbai",
    "description": "School Trip Mini Bus Mumbai offers safe and spacious buses for school excursions, educational trips, and student outings. Equipped with comfortable seating and reliable drivers."
  },
  {
    "name": "Tourist Mini Bus Mumbai",
    "description": "Tourist Mini Bus Mumbai provides group transport for sightseeing, heritage tours, and city excursions. AC and non-AC options available with friendly and professional drivers."
  },
  {
    "name": "Affordable Mini Bus Rental",
    "description": "Affordable Mini Bus Rental Mumbai offers cost-effective solutions for group travel without compromising comfort or safety. Ideal for short trips, family outings, and corporate travel."
  },
  {
    "name": "Luxury Mini Bus Hire",
    "description": "Luxury Mini Bus Hire Mumbai provides premium buses with modern interiors, AC, and professional chauffeurs for a high-end group travel experience."
  },
  {
    "name": "Mini Bus for Weddings Mumbai",
    "description": "Mini Bus for Weddings Mumbai caters to wedding guest transport and family travel during wedding events. Comfortable, spacious, and reliable service for hassle-free travel."
  },
  {
    "name": "Airport Mini Bus Service",
    "description": "Airport Mini Bus Service Mumbai provides convenient airport pickups and drops for large groups. AC buses, punctual drivers, and luggage-friendly vehicles ensure smooth transfers."
  },
  {
    "name": "Group Travel Mini Bus Mumbai",
    "description": "Group Travel Mini Bus Mumbai specializes in transporting large groups for events, tours, and long-distance journeys. Comfortable seating and professional service guaranteed."
  },
  {
    "name": "City Tour Bus Rental",
    "description": "City Tour Bus Rental Mumbai offers mini buses for sightseeing and city tours. Ideal for tourist groups, school trips, and corporate excursions with AC and non-AC options."
  },
  {
    "name": "Online Mini Bus Booking Mumbai",
    "description": "Online Mini Bus Booking Mumbai allows easy booking of mini buses for city or outstation trips. Convenient, reliable, and available 24×7 for instant bookings."
  },
  {
    "name": "Long Trip Bus Rental Mumbai",
    "description": "Long Trip Bus Rental Mumbai provides comfortable buses for long-distance journeys and outstation travel. Spacious, AC-equipped, and driven by experienced chauffeurs."
  },
  {
    "name": "Best Mini Bus Service Mumbai",
    "description": "Best Mini Bus Service Mumbai offers top-rated mini bus rentals for all types of group travel, including corporate, family, and tourist trips. Professional drivers, AC options, and timely service guaranteed."
  }
],

"tableData": [
  ["Mini Bus Hire Mumbai", "20-Seater Bus Mumbai"],
  ["27-Seater Bus Rental", "AC Mini Bus Mumbai"],
  ["Mini Bus Outstation Mumbai", "Corporate Bus Rental Mumbai"],
  ["School Trip Mini Bus Mumbai", "Tourist Mini Bus Mumbai"],
  ["Affordable Mini Bus Rental", "Luxury Mini Bus Hire"],
  ["Mini Bus for Weddings Mumbai", "Airport Mini Bus Service"],
  ["Group Travel Mini Bus Mumbai", "City Tour Bus Rental"],
  ["Online Mini Bus Booking Mumbai", "Long Trip Bus Rental Mumbai"],
  ["Best Mini Bus Service Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mini Bus on Rent in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers mini bus rental services in Mumbai, perfect for group travel, corporate events, school trips, and comfortable intercity journeys."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Mini Buses",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced mini buses to ensure a smooth and comfortable ride for large groups."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Group Travel",
    "WhyChoosedescription": "Our professional drivers are familiar with Mumbai and surrounding routes, ensuring safe, timely, and hassle-free travel in a mini bus."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear, upfront pricing—fuel, tolls, and driver allowances included—making your mini bus rental stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your mini bus travel needs in Mumbai."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All mini buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your mini bus rental in Mumbai convenient and worry-free."
  }
]

















  }

const faqData = [
  {
    question: 'Can I rent a Mini Bus in Mumbai with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs provides Mini Bus on rent in Mumbai for large group travel, corporate outings, school trips, and outstation journeys.',
  },
  {
    question: 'How can I book a Mini Bus on rent in Mumbai?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for a quick and hassle-free booking.',
  },
  {
    question: 'Is a Mini Bus suitable for large group travel in Mumbai?',
    answer: 'Absolutely. Mini Buses are ideal for large groups, offering spacious seating, comfort, and convenience for city and outstation trips.',
  },
  {
    question: 'Are drivers experienced for Mini Bus rentals in Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and well-acquainted with Mumbai routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for Mini Bus rental?',
    answer: 'Yes, you can select any pickup and drop-off points within Mumbai or for outstation trips according to your convenience.',
  },
  {
    question: 'Is Mini Bus rental available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock Mini Bus rental services to accommodate any travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mini Bus rentals?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict hygiene and safety measures to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available for Mini Bus rental in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for Mini Bus bookings.',
  },
  {
    question: 'Is customer support available during Mini Bus rental trips in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mini Bus rental journey in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    feedback: 'Renting a Mini Bus from Shambhu Cabs in Mumbai was perfect for our corporate outing. Spacious and comfortable with a professional driver.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Rao',
    feedback: 'Highly satisfied with Shambhu Cabs’ Mini Bus rental service in Mumbai. Smooth booking and a comfortable ride for our large group.',
    rating: 5,
  },
];

































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus on Rent in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/mini-bus-mumbai.jpg",
  "description": "Shambhu Cabs offers Mini Bus rentals in Mumbai with 20-seater and 27-seater options. Perfect for corporate travel, school trips, tourist groups, weddings, airport transfers, city tours, and long-distance journeys. Comfortable AC and non-AC buses with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mini-bus-rental-mumbai"
  }
};




  return (
    <div>
<Helmet>
  <title>Mini Bus on Rent in Mumbai | 20 & 27 Seater | Shambhu Cabs</title>

  <meta
    name="description"
    content="Rent a Mini Bus in Mumbai with Shambhu Cabs. 20-seater and 27-seater options for corporate travel, school trips, tourist groups, weddings, airport transfers, city tours, and long-distance journeys. Comfortable AC and non-AC buses with professional drivers."
  />

  <meta
    name="keywords"
    content="Mini Bus Hire Mumbai, 20-Seater Bus Mumbai, 27-Seater Bus Rental, AC Mini Bus Mumbai, Mini Bus Outstation Mumbai, Corporate Bus Rental Mumbai, School Trip Mini Bus Mumbai, Tourist Mini Bus Mumbai, Affordable Mini Bus Rental, Luxury Mini Bus Hire, Mini Bus for Weddings Mumbai, Airport Mini Bus Service, Group Travel Mini Bus Mumbai, City Tour Bus Rental, Online Mini Bus Booking Mumbai, Long Trip Bus Rental Mumbai, Best Mini Bus Service Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinmumbai;